import { useRouter } from "next/router";
function useCheckDashboardContainer() {
  var _useRouter = useRouter(),
    pathname = _useRouter.pathname;
  if (pathname === "/dashboard") {
    return true;
  }
  return false;
}
export default useCheckDashboardContainer;